// AI Generated Service
import { Injectable } from '@angular/core';
import { environment } from '@monsido/ng2/core/constants/general.constant';
import { OauthService } from '@monsido/oauth/oauth.service';

/**
 * Get region details of current active region
 */
@Injectable({
    providedIn: 'root',
})
export class ActiveRegionService {
    constructor (
        private oauthService: OauthService,
    ) {}

    /**
     * Check if sought region aligns with active region
     */
    isInRegion (region: string): boolean {
        if (typeof region !== 'string') {
            return false;
        }

        if (['qa', 'staging', 'development', 'test'].indexOf(environment) > -1) {
            return true;
        }

        return this.getRegion() === region.toUpperCase();
    }

    // PROTECTED

    /**
     * Get the region name from the api path
     */
    private getRegion (): string {
        const apiPath = this.oauthService.getApiPath();
        const splitUrl = apiPath.split('.');
        return splitUrl[1]?.toUpperCase() || '';
    }
}
